/**
 * Schedule tool (tools/SCHEDULE).
 *
 * The one Schedule page for the whole application. It lives under Tools rather than in a per-mode
 * explore tree because a schedule belongs to the DAY, not to a boat, a dataset or a report — the
 * same running order is what everyone is watching, whichever part of the app they happen to be in.
 *
 * There is nothing to derive here any more. The page used to be handed a `live` flag so it knew
 * where to get its day from; it is now a library of daily PLANS with no date on them at all (see
 * components/reports/ScheduleReportSection.tsx), so every sidebar mode wants exactly the same
 * page and this file is a plain pass-through.
 */
import ScheduleReportSection from "@components/reports/ScheduleReportSection";

export default function ScheduleToolPage(props: Record<string, unknown>) {
  return <ScheduleReportSection {...props} />;
}
